import React from 'react'
import Carousel from '../Carousel/Carousel'
// import Modal from '../PopUp/Modal'
import Facts from '../Countdown/Facts'
import BookVenue from './HComponents/BookVenue/BookVenue'
import ChairmanMessage from './HComponents/ChairmanMessage/ChairmanMessage'
import UniqueSection from './HComponents/UniqueSection/UniqueSection'
import LearnAndLead from '../Learn&Lead/LearnandLead'
import PopupContact from '../Contact/PopupContact/PopupContact'


const Home = () => {
  return (
    <div>
      {/* <Modal/> */}
        <Carousel/>
        <LearnAndLead/>
        <Facts/>
        <BookVenue/>
        <ChairmanMessage/>
        <PopupContact/>
        <UniqueSection/>
      

      
    </div>
  )
}
                                                                                                                                
export default Home